import axios from 'axios';
import qs from 'qs';

import _ from 'lodash';

import {
  fetch_page_data_url,
  get_adverse_event_data_url,
  get_reporter_data_url,
  get_source_data_url,
  get_product_data_url,
} from '../Utility/DataSources';

export const FILTER_DATA = 'FILTER_DATA';
const debouncedFilterData = _.debounce((dispatch) => {
  dispatch({
    type: FILTER_DATA,
  });
}, 100);
const filterData = () => (dispatch) => debouncedFilterData(dispatch);

export const SETUP_COLUMNS = 'SETUP_COLUMNS';
export function setupColumns(columns) {
  return {
    type: SETUP_COLUMNS,

    columns,
  };
}

export const ADD_GROUP_COLUMN = 'ADD_GROUP_COLUMN';
export const REMOVE_GROUP_COLUMN = 'REMOVE_GROUP_COLUMN';
export const REORDER_GROUP_COLUMN = 'REORDER_GROUP_COLUMN';
export const TOGGLE_GROUP_COLUMN_SORT = 'TOGGLE_GROUP_COLUMN_SORT';
export function addGroupColumn(col) {
  return {
    type: ADD_GROUP_COLUMN,
    col,
  };
}
export function removeGroupColumn(col_id) {
  return {
    type: REMOVE_GROUP_COLUMN,
    col_id,
  };
}
export function reorderGroupColumn(col_id, cur_idx, new_idx) {
  return {
    type: REORDER_GROUP_COLUMN,
    col_id,
    cur_idx,
    new_idx,
  };
}
export function toggleGroupColumnSort(col_id) {
  return {
    type: TOGGLE_GROUP_COLUMN_SORT,
    col_id,
  };
}

export const CHANGE_SORT_COLUMN = 'CHANGE_SORT_COLUMN';
export function changeSortColumn(field) {
  return {
    type: CHANGE_SORT_COLUMN,
    field,
  };
}

export const TOGGLE_COLUMN_VISIBILITY = 'TOGGLE_COLUMN_VISIBILITY';
export const REORDER_COLUMN = 'REORDER_COLUMN';
export function toggleColumnVisibility(col_id) {
  return {
    type: TOGGLE_COLUMN_VISIBILITY,
    col_id,
  };
}
export function reorderColumn(cur_idx, new_idx) {
  return {
    type: REORDER_COLUMN,
    cur_idx,
    new_idx,
  };
}

export const UPDATE_FILTER = 'UPDATE_FILTER';
export function updateFilter(filter_field, filter_type, value) {
  return function(dispatch) {
    const updateAction = {
      type: UPDATE_FILTER,
      filter_field,
      filter_type,
      value,
    };
    dispatch(updateAction);
    dispatch(filterData());
  };
}

export const SHOW_DEFINED_VIEW = 'SHOW_DEFINED_VIEW';
export function showDefinedView(view) {
  return {
    type: SHOW_DEFINED_VIEW,
    view,
  };
}

export const UPDATE_ACTIVE_PAGE = 'UPDATE_ACTIVE_PAGE';
export const UPDATE_NUM_ITEMS_PER_PAGE = 'UPDATE_NUM_ITEMS_PER_PAGE';
export function updateActivePage(page) {
  return {
    type: UPDATE_ACTIVE_PAGE,
    page,
  };
}
export function updateNumItemsPerPage(num_items) {
  return {
    type: UPDATE_NUM_ITEMS_PER_PAGE,
    num_items,
  };
}

export const GET_PAGE_DATA_REQUEST = 'GET_PAGE_DATA_REQUEST';
export const GET_PAGE_DATA_SUCCESS = 'GET_PAGE_DATA_SUCCESS';
export const GET_PAGE_DATA_FAILURE = 'GET_PAGE_DATA_FAILURE';
/*
*These three functions are used to actually construct the actions that various components in the React app can dispatch to update the state
*/
function requestPageData() {
  return {
    type: GET_PAGE_DATA_REQUEST,
  };
}
function successPageData(data) {
  return {
    type: GET_PAGE_DATA_SUCCESS,
    data: data,
  };
}
function errorPageData(error) {
  return {
    type: GET_PAGE_DATA_FAILURE,
    error: error,
  };
}

export function fetchPageData() {
  return function(dispatch, getState) {
    dispatch(requestPageData());

    const dashboard = getState().dashboard || {};
    const token = _.get(getState(), 'authorization.access_token');

    const sortBy = dashboard.sortBy;
    const sortOrder = dashboard.sortOrder;
    const filters = dashboard.filters;
    const activePage = dashboard.activePage;
    const itemsPerPage = dashboard.itemsPerPage;

    //grouping needs to get the lates field information from the configured columns, in case the column fields have been re-named since the user saved their group settings
    const grouping = _.map(dashboard.grouping || [], (group) => {
      return Object.assign({}, group, {
        field: (_.find(dashboard.columns || [], (col) => {
          return col.ID === group.col_id;
        }) || {}).field,
      });
    });

    axios
      .request({
        url: fetch_page_data_url,
        method: 'get',
        params: {
          token,
          sortBy,
          sortOrder,
          filters: JSON.stringify(filters),
          activePage,
          itemsPerPage,
          grouping: JSON.stringify(grouping),
        },
      })
      .then(function(response) {
        dispatch(successPageData(response.data));
      })
      .catch(function(error) {
        console.error(error);
        dispatch(errorPageData(error));
      });
  };
}

export const GET_DETAIL_DATA_REQUEST = 'GET_DETAIL_DATA_REQUEST';
export const GET_DETAIL_DATA_SUCCESS = 'GET_DETAIL_DATA_SUCCESS';
export const GET_DETAIL_DATA_FAILURE = 'GET_DETAIL_DATA_FAILURE';
/*
*These three functions are used to actually construct the actions that various components in the React app can dispatch to update the state
*/
function requestDetailData(detail_type) {
  return {
    type: GET_DETAIL_DATA_REQUEST,
    detail_type,
  };
}
function successDetailData(data, detail_type) {
  return {
    type: GET_DETAIL_DATA_SUCCESS,
    data: data,
    detail_type,
  };
}
function errorDetailData(error, detail_type) {
  return {
    type: GET_DETAIL_DATA_FAILURE,
    error: error,
    detail_type,
  };
}

export function fetchDetailData(record_id, detail_type) {
  return function(dispatch, getState) {
    let request_url;

    switch (detail_type) {
      case 'adverse_event_detail':
        request_url = get_adverse_event_data_url;
        break;
      case 'reporter_detail':
        request_url = get_reporter_data_url;
        break;
      case 'product_detail':
        request_url = get_product_data_url;
        break;
      case 'source_detail':
        request_url = get_source_data_url;
        break;
      default:
        return;
    }
    const token = _.get(getState(), 'authorization.access_token');

    dispatch(requestDetailData(detail_type));

    axios
      .request({
        url: request_url,
        method: 'get',
        params: {
          record_id,
          token,
        },
      })
      .then(function(response) {
        dispatch(successDetailData(response.data, detail_type));
      })
      .catch(function(error) {
        console.error(error);
        dispatch(errorDetailData(error, detail_type));
      });
  };
}



// WEBPACK FOOTER //
// ./src/Actions/DashboardActions.js